import { type FC } from 'react'
import { Layout } from '@egw/layouts'
import { Headers } from '@egw/components'
import { useTranslation } from '@egw/i18n'
import { ExternalAccountDetailsPage } from '@egw/features-external-accounts'

export const SettingsExternalAccountDetailsPage: FC = () => {
  const { t } = useTranslation()
  return (
    <Layout>
      <Headers title={t('pages.settings.title')} />
      <ExternalAccountDetailsPage />
    </Layout>
  )
}
